import React, { useState } from 'react';
import { Input, Modal, Radio } from 'antd';

interface IProps {
    showMaterialColorModal: string | null;
    onHandleSubmit: (field: string, value: string) => void;
    handleModalCancel: () => void;
}

const PlasticMaterialPreferencesModal: React.FC<IProps> = props => {
    const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(true);
    const { showMaterialColorModal, onHandleSubmit, handleModalCancel } = props;
    const [value, setValue] = useState('');

    const handleSubmit = () => {
        if (showMaterialColorModal && value.trim()) {
            onHandleSubmit(showMaterialColorModal, value);
        }
    };

    return (
        <>
            <Modal
                title="Plastic Material Preferences"
                open={!!showMaterialColorModal}
                onOk={handleSubmit}
                onCancel={handleModalCancel}
                destroyOnClose={true}
                okButtonProps={{
                    disabled: isSubmitButtonDisabled,
                }}
                okText="Submit"
            >
                {showMaterialColorModal === 'transparent' ? (
                    <div className="flex flex-col gap-2">
                        <label className="font-medium">
                            Would you like the part to be optically clear (transparent)?
                        </label>

                        <Radio.Group
                            onChange={e => {
                                setValue(e.target.value);
                                setIsSubmitButtonDisabled(false);
                            }}
                        >
                            <Radio value="yes">Yes</Radio>
                            <Radio value="no">No</Radio>
                        </Radio.Group>
                    </div>
                ) : (
                    <div className="flex flex-col gap-2">
                        <label className="font-medium">
                            Please enter your preferred color (white, black, natural, etc.):
                        </label>

                        <Input
                            value={value}
                            onChange={e => {
                                setValue(e.target.value);
                                setIsSubmitButtonDisabled(e.target.value.trim() === '');
                            }}
                        />
                    </div>
                )}
            </Modal>
        </>
    );
};

export default PlasticMaterialPreferencesModal;
